// Small numeric helpers shared by the studio's model, the 2D plan and the 3D scene. Pure, no imports,
// so node --test loads it and both packages can use it.

/** Rounds to `decimals` places; never returns -0, which would print as "-0" and fail strict equality. */
export function roundTo(value: number, decimals = 1): number {
    const factor = 10 ** decimals;
    return Math.round(value * factor) / factor + 0;
}

export function clamp(value: number, min: number, max: number): number {
    return Math.min(max, Math.max(min, value));
}

/** Middle value of `values` (mean of the two middle ones for an even count); 0 for none. */
export function median(values: readonly number[]): number {
    if (values.length === 0) return 0;
    const sorted = [...values].sort((a, b) => a - b);
    const middle = sorted.length >> 1;
    return sorted.length % 2 === 1 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
}
